// extracted by mini-css-extract-plugin
export default {"wrap":"NotFoundPage_wrap__3SQ51","title":"NotFoundPage_title__T85OS","text":"NotFoundPage_text__ek0zY"};